import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useActiveProject, useCanvasId } from "@/utils/utils";
import { STORYBOARD_TYPES } from "@/utils/constants";
import { getTempobookUrlFilePath } from "@/utils/sharedUtils";

export const useStoryboardUrl = (storyboard: any) => {
  const canvasId = useCanvasId();
  const project = useActiveProject();
  const canvasIdToDevServerUrl = useSelector(
    (state: any) => state.iframe.canvasIdToDevServerUrl
  );
  const devServerUrl = canvasIdToDevServerUrl[canvasId];

  const baseStoryboardUrl = useMemo(() => {
    if (!devServerUrl) {
      return "";
    }

    const calculatedTempobookUrlPath = getTempobookUrlFilePath(
      canvasId,
      project,
      storyboard.fullFilePath || "",
      storyboard.type === STORYBOARD_TYPES.STORY
        ? storyboard.storyComponentName || storyboard.name
        : storyboard.storyComponentName
    );

    let url: string;
    if (storyboard.type === STORYBOARD_TYPES.APPLICATION) {
      url = devServerUrl;
    } else if (!storyboard.created) {
      return "";
    } else {
      url = `${devServerUrl}${calculatedTempobookUrlPath}?storyboard=true&type=${storyboard.type}`;
    }

    const parsedUrl = new URL(url);
    if (import.meta.env.VITE_DEBUG_LOG_DEVTOOLS) {
      parsedUrl.searchParams.set("debugLog", "true");
    }
    if (project?.framework) {
      parsedUrl.searchParams.set("framework", project?.framework);
    }

    return parsedUrl.toString();
  }, [
    devServerUrl,
    project,
    storyboard.type,
    storyboard.created,
    storyboard.fullFilePath,
    storyboard.storyComponentName,
    storyboard.name,
    canvasId,
  ]);

  return baseStoryboardUrl;
};
